import { render, staticRenderFns } from "./viewContact.vue?vue&type=template&id=936c0fcc&scoped=true"
import script from "./viewContact.vue?vue&type=script&lang=js"
export * from "./viewContact.vue?vue&type=script&lang=js"
import style0 from "./viewContact.vue?vue&type=style&index=0&id=936c0fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936c0fcc",
  null
  
)

export default component.exports